'use client'
import { useToast } from '@/components/ui/use-toast'
import { useFullDomainUrl } from '@/hooks/use-full-domain-url'
import { cn } from '@/utils/cn'
import { useCopyToClipboard } from '@uidotdev/usehooks'
import Image from 'next/image'

export const ProductShareButton = ({ className }: { className?: string }) => {
  const domain = useFullDomainUrl()
  const [_, copyToClipboard] = useCopyToClipboard()
  const { toast } = useToast()

  async function share(url: string) {
    if (navigator.share) {
      try {
        await navigator.share({
          title: document.title,
          url,
        })
      } catch (_) {
        await copyToClipboard(url)
        toast({
          title: 'URL 복사가 완료되었어요!',
          duration: 2000,
        })
      }
    } else {
      await copyToClipboard(url)
      toast({
        title: 'URL 복사가 완료되었어요!',
        duration: 2000,
      })
    }
  }
  return (
    <button
      id={''} // TODO: GA 이벤트 추가
      onClick={() => share(domain)}
      className={cn(
        'rounded-full border border-[#C9C9C9] bg-[#FFFFFF] p-[10px] drop-shadow-[0_2px_4px_rgba(0,0,0,0.15)]',
        className,
      )}
    >
      <Image src="/icons/share.svg" alt="" width={20} height={20} />
      <span className="sr-only">공유</span>
    </button>
  )
}
